<template>
    <section>
        <div class="calendarModal" :class="{ 'calendarModalOpen': calendarModalState === true }">
            <div class="modalHeader" @click="calendarModalState = false">
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                    <path d="M6 0.5L1 7.5L6 14.5" stroke="#464D5B" />
                </svg>
                <p>Cambiar Semana</p>
            </div>
            <div class="infoCard">
                <div class="calendarCont">
                    <h5>{{ calendarioFechaSeleccionada.format('MMMM YYYY') }}</h5>
                    <div class="calendar">
                        <div class="calendarHead">
                            <div class="dayLabel">Lun</div>
                            <div class="dayLabel">Mar</div>
                            <div class="dayLabel">Mie</div>
                            <div class="dayLabel">Jue</div>
                            <div class="dayLabel">Vie</div>
                            <div class="dayLabel">Sab</div>
                            <div class="dayLabel">Dom</div>
                        </div>

                        <div class="dayCont">

                            <div class="day passed" v-for="n in diasPrevios">
                                <p>{{ n }}</p>
                            </div>

                            <button
                                :class="{ 'today': !mesCambiado && diaActual === n, 'diaCalSel': diaSeleccionado && diaSeleccionado.date() === n }"
                                class="day" v-for="n in diasDelMes" @click="cambiarDia(n), userChangeWeek()">
                                <p>{{ n < 10 ? '0' + n : n }}</p>
                            </button>

                            <div class="day passed" v-for="n in (-ultimoDiaDelMes + 6)">
                                <p>{{ n }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" changeMonth">
                    <button @click="retrocederMes()" class="prevMonth">
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                            <path d="M6 0.5L1 7.5L6 14.5" stroke="#464D5B" stroke-linecap="round" />
                        </svg>
                    </button>
                    <button @click="avanzarMes()" :disabled="botonDesactivado" class="nextMonth">
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                            <path d="M1 14.5L6 7.5L1 0.5" stroke="#464D5B" stroke-linecap="round" />
                        </svg>
                    </button>

                </div>

            </div>
        </div>
        <div class="backdropCalendarModal" :class="{ 'backdropShown': calendarModalState === true }"
            @click="calendarModalState = false"></div>
        <div class="goBack" @click="linkTo('inicio')">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
                <path d="M6 0.500122L1 7.50012L6 14.5001" stroke="#464D5B" stroke-linecap="round" />
            </svg>
            <p>Calendario Semanal</p>
        </div>
        <template v-if="weekplan.week">
            <hr class="mov">
            <div class="row">
                <span v-if="weekplan.week">
                    {{ formatDate(weekplan.week[0]?.date) }} - {{ formatDate(weekplan.week[weekplan.week.length -
                        1]?.date) }}
                </span>
                <span v-else>
                    No data available
                </span>
                <h3 v-if="weekplan">{{ formatMonth(weekplan.week[0].date) }}</h3>
                <button class="changeWeek" @click="calendarModalState = true">
                    <p>Cambiar de Semana</p>
                    <specialButtonMicro class="rotate" />
                </button>

            </div>
            <hr class="mov">

            <div class="weekSelector">
                <div v-if="weekplan">
                </div>
                <div class="dayContainer" v-for="dia in weekplan.week" :key="dia.date">
                    <button class="finish" @click="enviarInfo(dia, 'completado')"
                        :disabled="formatDate(dia?.date) > today">
                        <div class="filled" v-if="dia.progress[0]?.completed"></div>
                    </button>
                    <button class=" daySelect" @click="selectDayMethod(dia), clearCurrentInfo()"
                        :class="{ 'selected': selectDay === dia }">
                        <p>{{ dia.date.slice(8, 10) }}</p>

                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="7" viewBox="0 0 16 7" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M15.8604 0.478253C16.1011 0.815313 16.023 1.28373 15.686 1.52448L8.68599 6.52448L8.25006 6.83586L7.81413 6.52448L0.81413 1.52448C0.47707 1.28373 0.399001 0.815313 0.639758 0.478254C0.880515 0.141194 1.34893 0.0631256 1.68599 0.303882L8.25006 4.9925L14.8141 0.303882C15.1512 0.063125 15.6196 0.141194 15.8604 0.478253Z"
                                fill="#464D5B" />
                        </svg>
                    </button>
                </div>
            </div>
            <div v-if="selectDay" class="infoCard">
                <span> {{ formatDay(selectDay.date) }} </span>

                <hr>
                <div class="dayInfoCont">
                    <section class="dayClass">
                        <div class="dayClassTitle">
                            <h4>Clase del Día</h4>
                        </div>
                        <div @click="goToClass(clase.title, clase.id, weekplan.id)" v-for="clase in selectDay.classes"
                            class="classOfDay">
                            <div class="classOfDayImage">
                                <div class="classVideoPlay">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="38" viewBox="0 0 22 38"
                                        fill="none">
                                        <path
                                            d="M1 35.9902V2.34364C1 1.46296 2.05606 1.0123 2.6919 1.62165L20.2466 18.4449C20.6574 18.8386 20.6574 19.4952 20.2466 19.8889L2.69191 36.7122C2.05606 37.3215 1 36.8709 1 35.9902Z"
                                            stroke="white" />
                                    </svg>
                                </div>
                                <div class="classDificulty">
                                    <template v-if="clase.intensity === 'Baja'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                            viewBox="0 0 12 13" fill="none">
                                            <path
                                                d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                                fill="url(#paint0_linear_3899_5474)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                    x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0.23516" stop-color="#4536EF" />
                                                    <stop offset="0.913242" stop-color="#FF00B8" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <svg class="disabled" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                            viewBox="0 0 12 13" fill="none">
                                            <path
                                                d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                                fill="url(#paint0_linear_3899_5474)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                    x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0.23516" stop-color="#4536EF" />
                                                    <stop offset="0.913242" stop-color="#FF00B8" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <svg class="disabled" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                            viewBox="0 0 12 13" fill="none">
                                            <path
                                                d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                                fill="url(#paint0_linear_3899_5474)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                    x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0.23516" stop-color="#4536EF" />
                                                    <stop offset="0.913242" stop-color="#FF00B8" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </template>
                                    <template v-if="clase.intensity === 'Media'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                            viewBox="0 0 12 13" fill="none">
                                            <path
                                                d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                                fill="url(#paint0_linear_3899_5474)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                    x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0.23516" stop-color="#4536EF" />
                                                    <stop offset="0.913242" stop-color="#FF00B8" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                            viewBox="0 0 12 13" fill="none">
                                            <path
                                                d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                                fill="url(#paint0_linear_3899_5474)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                    x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0.23516" stop-color="#4536EF" />
                                                    <stop offset="0.913242" stop-color="#FF00B8" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <svg class="disabled" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                            viewBox="0 0 12 13" fill="none">
                                            <path
                                                d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                                fill="url(#paint0_linear_3899_5474)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                    x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0.23516" stop-color="#4536EF" />
                                                    <stop offset="0.913242" stop-color="#FF00B8" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </template>
                                    <template v-if="clase.intensity === 'Alta'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                            viewBox="0 0 12 13" fill="none">
                                            <path
                                                d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                                fill="url(#paint0_linear_3899_5474)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                    x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0.23516" stop-color="#4536EF" />
                                                    <stop offset="0.913242" stop-color="#FF00B8" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                            viewBox="0 0 12 13" fill="none">
                                            <path
                                                d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                                fill="url(#paint0_linear_3899_5474)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                    x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0.23516" stop-color="#4536EF" />
                                                    <stop offset="0.913242" stop-color="#FF00B8" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                                            viewBox="0 0 12 13" fill="none">
                                            <path
                                                d="M1.85 7.46216C1.85 8.20621 2.02655 8.89871 2.37965 9.53963C2.73263 10.1806 3.21797 10.6974 3.83568 11.0903C3.78117 10.9861 3.74212 10.8822 3.71853 10.7785C3.69507 10.6749 3.68333 10.5662 3.68333 10.4527C3.68333 10.1109 3.74848 9.78903 3.87877 9.48702C4.00893 9.18502 4.19575 8.91144 4.43922 8.6663L6.25 6.87292L8.06775 8.6663C8.31134 8.91144 8.49706 9.18502 8.6249 9.48702C8.75274 9.78903 8.81667 10.1109 8.81667 10.4527C8.81667 10.5662 8.80493 10.6749 8.78147 10.7785C8.75788 10.8822 8.71883 10.9861 8.66432 11.0903C9.28203 10.6974 9.76737 10.1806 10.1203 9.53963C10.4735 8.89871 10.65 8.20621 10.65 7.46216C10.65 6.84683 10.5369 6.26534 10.3108 5.7177C10.0847 5.17006 9.75778 4.68087 9.33 4.25014C9.08556 4.41013 8.82889 4.53011 8.56 4.61011C8.29111 4.6901 8.01611 4.7301 7.735 4.7301C6.97258 4.7301 6.31331 4.47781 5.7572 3.97324C5.20109 3.46867 4.88258 2.84245 4.80167 2.09458C4.325 2.49602 3.90333 2.91518 3.53667 3.35207C3.17 3.78895 2.86139 4.23433 2.61083 4.68819C2.36028 5.14218 2.17083 5.603 2.0425 6.07065C1.91417 6.5383 1.85 7.00214 1.85 7.46216ZM6.25 8.42207L5.205 9.45583C5.07056 9.5912 4.96667 9.74503 4.89333 9.91732C4.82 10.0896 4.78333 10.2681 4.78333 10.4527C4.78333 10.8465 4.92694 11.1849 5.21417 11.468C5.50139 11.751 5.84667 11.8925 6.25 11.8925C6.65333 11.8925 6.99861 11.751 7.28583 11.468C7.57306 11.1849 7.71667 10.8465 7.71667 10.4527C7.71667 10.2558 7.68 10.0742 7.60667 9.90809C7.53333 9.74195 7.42944 9.5912 7.295 9.45583L6.25 8.42207ZM5.88333 0.00012207V1.77652C5.88333 2.29905 6.06221 2.73735 6.41995 3.09141C6.77769 3.44547 7.21604 3.6225 7.735 3.6225C7.95964 3.6225 8.17378 3.57992 8.3774 3.49476C8.5809 3.4096 8.76778 3.28413 8.93803 3.11836L9.26088 2.79052C10.0337 3.28844 10.6417 3.95275 11.085 4.78345C11.5283 5.61414 11.75 6.50704 11.75 7.46216C11.75 9.00713 11.2169 10.3164 10.1508 11.3899C9.08464 12.4634 7.78438 13.0001 6.25 13.0001C4.71562 13.0001 3.41536 12.4634 2.34922 11.3899C1.28307 10.3164 0.75 9.00713 0.75 7.46216C0.75 6.03558 1.21163 4.6629 2.1349 3.34413C3.05817 2.02548 4.30764 0.910809 5.88333 0.00012207Z"
                                                fill="url(#paint0_linear_3899_5474)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3899_5474" x1="0.75" y1="6.50012"
                                                    x2="11.75" y2="6.50012" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0.23516" stop-color="#4536EF" />
                                                    <stop offset="0.913242" stop-color="#FF00B8" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </template>
                                </div>
                                <div class="classTime">
                                    <p>{{ Math.floor(clase.duration / 60) }}:{{ (clase.duration %
                                        60).toString().padStart(2,
                                            '0') }} min</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12"
                                        fill="none">
                                        <path
                                            d="M5.50303 11.5002C3.96679 11.5002 2.66553 10.9671 1.59924 9.90084C0.533081 8.8347 0 7.53346 0 5.99713C0 4.47241 0.533081 3.17508 1.59924 2.10514C2.66553 1.03521 3.96679 0.500244 5.50303 0.500244C7.0279 0.500244 8.32524 1.03521 9.39507 2.10514C10.465 3.17508 11 4.47241 11 5.99713C11 7.53346 10.465 8.8347 9.39507 9.90084C8.32524 10.9671 7.0279 11.5002 5.50303 11.5002ZM5.49991 10.4002C6.72215 10.4002 7.76106 9.97247 8.61663 9.11691C9.4722 8.26136 9.89998 7.22247 9.89998 6.00024C9.89998 4.77802 9.4722 3.73913 8.61663 2.88358C7.76106 2.02802 6.72215 1.60024 5.49991 1.60024C4.27767 1.60024 3.23876 2.02802 2.38319 2.88358C1.52762 3.73913 1.09983 4.77802 1.09983 6.00024C1.09983 7.22247 1.52762 8.26136 2.38319 9.11691C3.23876 9.97247 4.27767 10.4002 5.49991 10.4002ZM7.23885 8.54143L8.02298 7.75749L6.04992 5.78446V3.17966H4.9499V6.23436L7.23885 8.54143Z"
                                            fill="white" />
                                    </svg>
                                </div>
                                <div class="backdrop"></div>
                                <img v-if="!clase.image" src="../../assets/videoTemp.jpg" alt="">
                                <img v-else :src="srcImg(clase.image)" alt="">
                            </div>
                            <div class="classOfDayInfo">
                                <p> {{ clase.categories[0].name }} </p>
                                <h5> {{ clase.title }}</h5>
                                <span>{{ clase.method }}</span>
                                <h6>{{ formatDay(clase.publishDate) }}</h6>
                            </div>
                        </div>

                        <template v-if="selectDay.showFeelings">
                            <h5>¿Cómo te sientes hoy?</h5>
                            <div class="moodList">

                                <button class="mood"
                                    :class="{ 'activeMood': selectDay.progress[0]?.feeling === 'excited' }"
                                    @click="useCurrentDayInfo.selectedMood = 'excited', enviarInfo(selectDay, 'mood')">
                                    <div class="moodImage">
                                        <img src="../../assets/svg/moods/excited_active.svg" alt="">
                                        <svg class="noshow" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                stroke="#E3E3E9" />
                                        </svg>
                                        <svg class="show" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint0_linear_3808_6804)" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint1_linear_3808_6804)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <p>excited</p>
                                </button>
                                <button class="mood"
                                    :class="{ 'activeMood': selectDay.progress[0]?.feeling === 'confident' }"
                                    @click="useCurrentDayInfo.selectedMood = 'confident', enviarInfo(selectDay, 'mood')">
                                    <div class="moodImage">
                                        <img src="../../assets/svg/moods/confident_active.svg" alt="">
                                        <svg class="noshow" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                stroke="#E3E3E9" />
                                        </svg>
                                        <svg class="show" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint0_linear_3808_6804)" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint1_linear_3808_6804)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <p>confident</p>
                                </button>
                                <button class="mood"
                                    :class="{ 'activeMood': selectDay.progress[0]?.feeling === 'happy' }"
                                    @click="useCurrentDayInfo.selectedMood = 'happy', enviarInfo(selectDay, 'mood')">
                                    <div class="moodImage">
                                        <img src="../../assets/svg/moods/happy_active.svg" alt="">
                                        <svg class="noshow" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                stroke="#E3E3E9" />
                                        </svg>
                                        <svg class="show" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint0_linear_3808_6804)" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint1_linear_3808_6804)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <p>happy</p>
                                </button>
                                <button class="mood"
                                    :class="{ 'activeMood': selectDay.progress[0]?.feeling === 'neutral' }"
                                    @click="useCurrentDayInfo.selectedMood = 'neutral', enviarInfo(selectDay, 'mood')">
                                    <div class="moodImage">
                                        <img src="../../assets/svg/moods/indifferent_active.svg" alt="">
                                        <svg class="noshow" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                stroke="#E3E3E9" />
                                        </svg>
                                        <svg class="show" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint0_linear_3808_6804)" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint1_linear_3808_6804)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <p>neutral</p>
                                </button>
                                <button class="mood"
                                    :class="{ 'activeMood': selectDay.progress[0]?.feeling === 'tired' }"
                                    @click="useCurrentDayInfo.selectedMood = 'tired', enviarInfo(selectDay, 'mood')">
                                    <div class="moodImage">
                                        <img src="../../assets/svg/moods/tired_active.svg" alt="">
                                        <svg class="noshow" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                stroke="#E3E3E9" />
                                        </svg>
                                        <svg class="show" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint0_linear_3808_6804)" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint1_linear_3808_6804)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <p>tired</p>
                                </button>
                                <button class="mood" :class="{ 'activeMood': selectDay.progress[0]?.feeling === 'sad' }"
                                    @click="useCurrentDayInfo.selectedMood = 'sad', enviarInfo(selectDay, 'mood')">
                                    <div class="moodImage">
                                        <img src="../../assets/svg/moods/sad_active.svg" alt="">
                                        <svg class="noshow" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                stroke="#E3E3E9" />
                                        </svg>
                                        <svg class="show" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint0_linear_3808_6804)" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint1_linear_3808_6804)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <p>sad</p>
                                </button>
                                <button class="mood"
                                    :class="{ 'activeMood': useCurrentDayInfo.selectedMood === 'angry' || selectDay.progress[0]?.feeling === 'angry' }"
                                    @click="useCurrentDayInfo.selectedMood = 'angry', enviarInfo(selectDay, 'mood')">
                                    <div class="moodImage">
                                        <img src="../../assets/svg/moods/angry_active.svg" alt="">
                                        <svg class="noshow" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="white" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                stroke="#E3E3E9" />
                                        </svg>
                                        <svg class="show" xmlns="http://www.w3.org/2000/svg" width="69" height="70"
                                            viewBox="0 0 69 70" fill="none">
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint0_linear_3808_6804)" />
                                            <path
                                                d="M29.3227 12.4888C25.4924 -4.16295 43.5076 -4.16295 39.6773 12.4888C43.5076 -4.16295 59.7383 3.59349 49.008 16.9467C59.7406 3.59349 70.9727 17.5696 55.4636 24.9828C70.9727 17.5719 74.9817 35.0011 57.7682 35.0011C74.9817 35.0011 70.9727 52.4304 55.4636 45.0195C70.9727 52.4304 59.7383 66.4088 49.008 53.0533C59.7406 66.4065 43.5076 74.1652 39.6773 57.5112C43.5076 74.1629 25.4924 74.1629 29.3227 57.5112C25.4924 74.1629 9.26166 66.4065 19.992 53.0533C9.25937 66.4065 -1.97269 52.4304 13.5364 45.0195C-1.97269 52.4304 -5.98168 35.0011 11.2318 35.0011C-5.98168 35.0011 -1.97269 17.5719 13.5364 24.9828C-1.97269 17.5719 9.26166 3.59349 19.992 16.949C9.25937 3.59349 25.4924 -4.16295 29.3227 12.4888Z"
                                                fill="url(#paint1_linear_3808_6804)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_3808_6804" x1="0" y1="35" x2="69"
                                                    y2="35" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#FFE711" />
                                                    <stop offset="1" stop-color="#96FF11" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                    <p>angry</p>
                                </button>

                            </div>
                        </template>
                        <section class="dayRecipe mov">
                            <h5>Receta del Día</h5>
                            <div @click="showModal = !showModal" class="dayRecipePrev"
                                v-for="recipe in selectDay.recipes" :key="recipe.id">
                                <div class="dayRecipePrevImg">
                                    <div class="backdrop"></div>
                                    <img v-if="recipe.mobileImg" :src="srcRecipeImg(recipe.id, recipe.mobileImg)"
                                        alt="">
                                    <img v-else src="../../assets/recipeTemp.png" alt="">
                                </div>
                                <div class="dayRecipePrevInfo">
                                    <p>{{ recipe.title }}</p>
                                </div>
                            </div>
                            <template v-if="selectDay.tipOfDay">
                                <h5>Nota de Anabel</h5>
                                <div class="AnabelNote">
                                    <div v-html="selectDay.tipOfDay"></div>
                                </div>
                            </template>
                        </section>
                        <h5>Añadir una nota personal</h5>
                        <VueEditor id="description" v-model="noteModel" placeholder="Descripción" class="vue__editor"
                            :editor-toolbar="customToolbar" />
                        <div class="noteStatus">
                            <div v-if="loadingSendText" class="spinner"></div>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="23" height="17" viewBox="0 0 23 17"
                                fill="none">
                                <path
                                    d="M9.42559 10.3645L8.02559 8.9645C7.82559 8.7645 7.59225 8.6645 7.32559 8.6645C7.05892 8.6645 6.82559 8.7645 6.62559 8.9645C6.42559 9.1645 6.32559 9.402 6.32559 9.677C6.32559 9.952 6.42559 10.1895 6.62559 10.3895L8.75059 12.5395C8.95059 12.7395 9.18392 12.8395 9.45059 12.8395C9.71725 12.8395 9.95059 12.7395 10.1506 12.5395L14.3756 8.3145C14.5756 8.1145 14.6756 7.87284 14.6756 7.5895C14.6756 7.30617 14.5756 7.0645 14.3756 6.8645C14.1756 6.6645 13.9339 6.5645 13.6506 6.5645C13.3673 6.5645 13.1256 6.6645 12.9256 6.8645L9.42559 10.3645ZM5.60059 16.2395C4.08392 16.2395 2.78809 15.7145 1.71309 14.6645C0.638086 13.6145 0.100586 12.3312 0.100586 10.8145C0.100586 9.5145 0.492253 8.35617 1.27559 7.3395C2.05892 6.32284 3.08392 5.67284 4.35059 5.3895C4.76725 3.85617 5.60059 2.6145 6.85059 1.6645C8.10059 0.714502 9.51725 0.239502 11.1006 0.239502C13.0506 0.239502 14.7048 0.918669 16.0631 2.277C17.4214 3.63534 18.1006 5.2895 18.1006 7.2395C19.2506 7.37284 20.2048 7.86867 20.9631 8.727C21.7214 9.58534 22.1006 10.5895 22.1006 11.7395C22.1006 12.9895 21.6631 14.052 20.7881 14.927C19.9131 15.802 18.8506 16.2395 17.6006 16.2395H5.60059ZM5.60059 14.2395H17.6006C18.3006 14.2395 18.8923 13.9978 19.3756 13.5145C19.8589 13.0312 20.1006 12.4395 20.1006 11.7395C20.1006 11.0395 19.8589 10.4478 19.3756 9.9645C18.8923 9.48117 18.3006 9.2395 17.6006 9.2395H16.1006V7.2395C16.1006 5.85617 15.6131 4.677 14.6381 3.702C13.6631 2.727 12.4839 2.2395 11.1006 2.2395C9.71725 2.2395 8.53809 2.727 7.56309 3.702C6.58809 4.677 6.10059 5.85617 6.10059 7.2395H5.60059C4.63392 7.2395 3.80892 7.58117 3.12559 8.2645C2.44225 8.94784 2.10059 9.77284 2.10059 10.7395C2.10059 11.7062 2.44225 12.5312 3.12559 13.2145C3.80892 13.8978 4.63392 14.2395 5.60059 14.2395Z"
                                    fill="#cccccc" />
                            </svg>
                        </div>
                    </section>

                    <section class="dayRecipe pc">
                        <h5>Receta del Día</h5>
                        <div @click="showModal = !showModal" class="dayRecipePrev" v-for="recipe in selectDay.recipes"
                            :key="recipe.id">
                            <div class="dayRecipePrevImg">
                                <div class="backdrop"></div>
                                <img v-if="recipe.webImg" :src="srcRecipeImg(recipe.id, recipe.webImg)" alt="">
                                <img v-else src="../../assets/recipeTemp.png" alt="">
                            </div>
                            <div class="dayRecipePrevInfo">
                                <p>{{ recipe.title }}</p>
                            </div>
                        </div>
                        <template v-if="selectDay.tipOfDay">
                            <h5>Nota de Anabel</h5>
                            <div class="AnabelNote">
                                <div v-html="selectDay.tipOfDay" class="text"></div>
                            </div>
                        </template>
                    </section>
                </div>
            </div>
            <recetasCard v-if="showModal" :recipe="selectDay.recipes[0]" @close="closeModal" />
        </template>
        <template v-else>
            <p class="errorMSG">No se encontro una semana programada <span @click="setToday()">volver a la semana
                    actual</span></p>
        </template>

    </section>
</template>


<script>
import { VueEditor } from "vue2-editor";
import specialButtonMicro from "../specialButtonMicro.vue";
import dayjs from "dayjs";
import isoWeek from 'dayjs/plugin/isoWeek';
import 'dayjs/locale/es'; // Importar el idioma español
import { mapActions } from 'vuex';
import { url } from '../../global/index';
import recetasCard from "../recipeModal.vue";

dayjs.extend(isoWeek);
dayjs.locale('es');

export default {
    name: "App",
    data() {
        return {
            fechaSeleccionada: dayjs(),
            today: new Date().toISOString().split('T')[0], // Otravez la fecha actual...
            semanaSeleccionada: [],
            finishedDay: false,
            selectDay: [],
            hasSelectDayChanged: false,
            diasTerminados: [],
            selectedMood: null,
            customToolbar: [
                [],
            ],
            useCurrentDayInfo: {
                completed: false,
                selectedMood: null,
                note: null,
            },
            loadingSendText: false,
            timeout: null,
            noteInput: '',
            isEditing: false,
            showModal: false,
            calendarModalState: false,

            // calendarioLogic

            calendarioFechaSeleccionada: dayjs(),
            mesCambiado: false,
            botonDesactivado: false,
            diaSeleccionado: dayjs(),
        };
    },
    components: {
        VueEditor,
        specialButtonMicro,
        recetasCard,

    },

    async created() {
        const response = await this.getAllInfoWkp('weekplan?startDate=' + this.today);
        if (response.success) {
            this.semanaSeleccionada = this.weekplan.week;
            const hoy = dayjs().format('YYYY-MM-DD');
            this.selectDay = this.semanaSeleccionada.find(dia => dayjs(dia.date).format('YYYY-MM-DD') === hoy) || this.semanaSeleccionada[0];
        }
    },
    computed: {
        weekplan() {
            const data = this.$store.getters['weekPlan/data'];
            if (!(data instanceof Object) || data === null) return { week: [] };

            return data;
        },
        noteModel: {
            get() {
                return this.selectDay?.progress?.[0]?.note || this.useCurrentDayInfo.note;
            },
            set(value) {
                if (Array.isArray(this.selectDay.progress) && this.selectDay.progress.length > 0) {
                    this.selectDay.progress[0].note = value;
                } else {
                    this.useCurrentDayInfo.note = value;
                }
                this.noteInput = value; // Sincroniza noteInput con noteModel
            }
        },

        // calendarioLogic

        diasDelMes() {
            return this.calendarioFechaSeleccionada.daysInMonth();
        },
        diasDelMesAnterior() {
            return this.calendarioFechaSeleccionada.subtract(1, 'month').daysInMonth();
        },
        diaActual() {
            return this.calendarioFechaSeleccionada.date();
        },
        primerDiaDelMes() {
            const dia = this.calendarioFechaSeleccionada.startOf('month').isoWeekday();
            return dia === 7 ? 0 : dia; // Ajustar para que lunes sea 0
        },
        ultimoDiaDelMes() {
            return this.calendarioFechaSeleccionada.endOf('month').day();
        },
        diasPrevios() {
            const totalDiasAnterior = this.calendarioFechaSeleccionada.subtract(1, 'month').daysInMonth();
            const diasNecesarios = this.primerDiaDelMes === 0 ? 6 : this.primerDiaDelMes - 1;
            return Array.from({ length: diasNecesarios }, (_, i) => totalDiasAnterior - i).reverse();
        },
    },

    methods: {
        ...mapActions('weekPlan', ['getAllInfoWkp']),

        linkTo(enlace) {
            const query = enlace;
            if (query) {
                const currentQuery = this.$route.query.a;

                // Verifica si la búsqueda actual es la misma que la nueva búsqueda
                if (query !== currentQuery) {
                    this.$router.push({ path: '/web-app', query: { a: query } });
                    document.getElementById('up').scrollIntoView();

                } else {
                }
            } else {
            }
        },
        formatDay(day) {
            return dayjs(day).format('DD [de] MMMM YYYY');
        },

        formatDate(day) {
            if (!day) {
                return
            }
            return dayjs(day).format('YYYY-MM-DD');
        },

        formatMonth(day) {
            return dayjs(day).format('MMMM YYYY');
        },
        srcImg: function (img) {
            if (!img || img == "") {
                return "";
            }
            let src = `${url}/class-image/${img}`;

            return src;
        },
        srcRecipeImg: function (idRec, img) {
            if (!img || img == "") {
                return "";
            }
            let src = `${url}/recipe-image/${idRec}/${img}`;

            return src;
        },
        clearCurrentInfo() {
            this.useCurrentDayInfo = {
                selectedMood: null,
                note: null,
            }
        },
        closeModal() {
            this.showModal = false;
        },
        goToClass(className, id, weekplayID) {
            const idClass = id

            const nameClass = this.normalizeText(className)
            this.$router.push({ path: '/web-app', query: { a: 'clase', id: idClass, cN: nameClass, fromCalendar: weekplayID } });
        },
        normalizeText(texto) {
            const normal = texto
                .toLowerCase()
                .replace(/\s+/g, '-');

            return normal;
        },

        enviarInfo(dia, valor) {
            let data = {
                dayPlanId: dia.id,
                completed: false,
                feeling: null,
                note: null
            };

            if (dia.progress.length > 0) {
                data.completed = dia.progress[0].completed;
                data.feeling = dia.progress[0].feeling;
                data.note = dia.progress[0].note;
            }

            switch (valor) {
                case 'nota':
                    data.note = this.noteModel;
                    break;
                case 'completado':
                    data.completed = dia.progress.length > 0 ? !dia.progress[0].completed : true;
                    break;
                default:
                    data.feeling = this.useCurrentDayInfo.selectedMood;
                    break;
            }
            this.dispatchInfo(data);
        },
        async dispatchInfo(data) {
            let result = await this.$store.dispatch("daily/addItemDly", {
                option: "daily-activity",
                item: data,
            });
            if (result.success) {
                this.loadingSendText = false;
            }
            const response = await this.getAllInfoWkp('weekplan?startDate=' + this.today);
            if (response.success) {
                this.semanaSeleccionada = this.weekplan.week;
                const diaSeleccionadoAnteriormente = dayjs(this.selectDay.date).format('YYYY-MM-DD');
                this.selectDay = this.semanaSeleccionada.find(dia => dayjs(dia.date).format('YYYY-MM-DD') === diaSeleccionadoAnteriormente) || this.semanaSeleccionada[0];
            }
        },
        selectDayMethod(dia) {
            const diaSeleccionado = dia
            this.selectDay = diaSeleccionado,
                this.hasSelectDayChanged = true
        },

        // calendarioLogic

        /**
         * Cambia el mes actual sumando o restando meses
         * @param {number} cantidad - Número de meses a mover (positivo: adelante, negativo: atrás)
         */
        cambiarMes(cantidad) {
            // Calcular la nueva fecha
            const nuevaFecha = this.calendarioFechaSeleccionada.add(cantidad, 'month');

            // Verificar el límite inferior (diciembre 2024)
            const limiteFecha = dayjs('2024-12-01');

            if (cantidad < 0 && nuevaFecha.isBefore(limiteFecha, 'month')) {
                this.actualizarFechaCalendario(limiteFecha);
            } else {
                this.actualizarFechaCalendario(nuevaFecha);
            }
        },

        /**
         * Retrocede un mes en el calendario
         */
        retrocederMes() {
            this.cambiarMes(-1);
        },

        /**
         * Avanza un mes en el calendario
         */
        avanzarMes() {
            this.cambiarMes(1);
        },

        /**
         * Actualiza todas las propiedades relacionadas con la fecha del calendario
         * @param {Object|string} fecha - Fecha en formato dayjs o string (YYYY-MM-DD)
         */
        actualizarFechaCalendario(fecha) {
            // Asegurar que tenemos un objeto dayjs
            const fechaDayjs = dayjs.isDayjs(fecha) ? fecha : dayjs(fecha);

            // Obtener referencia del mes y año actual
            const fechaActual = dayjs();
            const mesActual = fechaActual.month();
            const añoActual = fechaActual.year();

            // Actualizar estado
            this.calendarioFechaSeleccionada = fechaDayjs;
            this.mesCambiado = fechaDayjs.month() !== mesActual || fechaDayjs.year() !== añoActual;

            // Seleccionar el primer día de la semana de la nueva fecha
            this.selectDay = fechaDayjs.startOf('week');
        },

        /**
         * Establece la fecha al día actual y carga la semana correspondiente
         */
        setToday() {
            this.calendarioFechaSeleccionada = dayjs();
            this.cambiarDia(dayjs().date());
            this.userChangeWeek();
        },


        cambiarDia(dia) {
            if (dia < 1 || dia > 31) {
                console.warn('Día inválido:', dia);
                return;
            }

            this.diaSeleccionado = this.calendarioFechaSeleccionada.date(dia);
        },

        /**
         * Carga los datos de la semana para la fecha seleccionada
         */
        async userChangeWeek() {
            this.calendarModalState = false;

            try {
                const startDate = this.diaSeleccionado.format('YYYY-MM-DD');
                const response = await this.getAllInfoWkp(`weekplan?startDate=${startDate}`);

                if (response.success && response.data?.week?.length) {
                    this.selectDay = response.data.week[0];
                } else {
                    console.warn('No se encontraron datos para la semana seleccionada');
                }
            } catch (error) {
                console.error('Error al cargar la semana:', error);
            }
        },
        esDiaFuturo(dia) {
            const fechaActual = dayjs();
            const fechaSeleccionadaCompleta = this.calendarioFechaSeleccionada.date(dia);

            // Si la fecha es futura, debe deshabilitarse
            return fechaSeleccionadaCompleta.isAfter(fechaActual, 'day');
        },
    }
};
</script>
<style scoped>
section {
    padding: 0 !important;
}

.goBack {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 1.041667vw;
    cursor: pointer;
    width: fit-content;
}

.goBack p {
    overflow: hidden;
    color: var(--Text, #464D5B);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: 2.777778vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    width: fit-content;
    align-self: center;
    text-transform: capitalize;
    background: linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

}

.row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.row span {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 20vw;
}

.weekSelector {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.041667vw;
}

.dayContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    flex: 1;

}

.daySelect {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: .833333vw 1.388889vw;


    border-radius: 2.083333vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    background: var(--White, #FFF);
    position: relative;
    cursor: pointer;
    width: 100%;
}

.daySelect:disabled {
    background: var(--White, #efeff1);

}

.daySelect:disabled svg {
    opacity: 0.5;
}

.selected::before {
    inset: -0.208333vw !important;

}

.daySelect::before {
    content: "";
    position: absolute;
    inset: .208333vw;
    background: linear-gradient(90deg, #4536EF 0%, #FF00B8 33%, #96FF11 66%, #FFE711 100%);
    background-size: 300%;
    background-position: 0% 0;
    z-index: -2;
    border-radius: 6.944444vw;
    animation: cycle 2s ease-in-out infinite alternate;
}

.daySelect svg {
    width: 1.076389vw;
    height: .463333vw;
    flex-shrink: 0;
    margin-left: auto;
}

.daySelect p {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: "SharpGrotesk-Medium25";
    font-size: 1.736111vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-left: 2.569444vw;
}

.finish {
    width: 1.875vw;
    height: 1.875vw;
    border-radius: 2.083333vw;
    border: .069444vw solid #b1b1b4;
    overflow: hidden;
    display: flex;

    padding: .238889vw;
    position: absolute;
    z-index: 2;
    left: 1.388889vw;
}

.filled {
    background: linear-gradient(90deg, #4536EF 0%, #FF00B8 33%, #96FF11 66%, #FFE711 100%);
    background-size: 300%;
    background-position: 0% 0;
    height: 100%;
    width: 100%;
    border-radius: 102.083333vw;
    animation: cycle 2s ease-in-out infinite alternate;

}

@keyframes cycle {
    0% {
        background-position: 0% 0;
    }

    100% {
        background-position: 100% 0;
    }
}

.infoCard {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.388889vw;
    padding: 1.388889vw;
    align-self: stretch;
    border-radius: 2.083333vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    background: var(--White, #FFF);
    position: relative;
}

.infoCard>span {
    overflow: hidden;
    color: var(--Text, #464D5B);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

hr {
    border: 0;
    background: #E3E3E9;
    min-height: .069444vw;
    width: 100%;
}

.dayInfoCont {
    display: flex;
    flex-direction: row;
    gap: 3.472222vw;
}

.dayClass {
    display: flex;
    flex-direction: column;
    gap: 1.388889vw;
    width: 55.069444vw;
    position: relative;
}

.dayRecipe {
    display: flex;
    flex-direction: column;
    gap: 1.388889vw;
    width: 34.305556vw;
}

h5 {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: 1.736111vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.dayClassTitle {
    display: flex;
    flex-direction: column;
    gap: .694444vw;
}

.dayClassTitle h4 {
    font-family: Manrope;
    font-size: 1.736111vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: fit-content;
}

.dayClassTitle span {
    color: var(--Text, #464D5B);
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 400;
    line-height: 1.736111vw;
    /* 208.333% */
}

.moodList {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.mood {
    display: flex;
    width: 5.902778vw;
    height: 8.402778vw;
    padding: 1.041667vw 0;
    flex-direction: column;
    align-items: center;
    gap: .763889vw;

    border-radius: 20.833333vw 20.833333vw 2.777778vw 2.777778vw;
    border: .069444vw solid #E3E3E9;
    background-color: #fff;

    transition: all 300ms ease;
}

.activeMood {
    background-color: #B359F8;
}

.activeMood p {
    color: #fff !important;
}

.activeMood .moodImage img {
    filter: brightness(1) contrast(1) !important;

}

.activeMood .show {
    opacity: 1;
    rotate: 180deg;
}

.activeMood .noshow {
    opacity: 0;
}

.mood p {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: "SharpGrotesk-Medium25";
    font-size: .694444vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
    transition: all 300ms ease;
}

.moodImage {
    position: relative;
    width: 100%;
    width: 4.861111vw;
    height: 4.861111vw;
    display: flex;
    align-items: center;
    justify-content: center;
}

.moodImage svg {
    position: absolute;
    left: 0;
    top: 0;
    width: 4.791667vw;
    height: 4.861111vw;
    z-index: 2;
}

.moodImage img {
    z-index: 3;
    position: relative;
    filter: brightness(0) contrast(0.2);
    transition: all 300ms ease;
    height: 2.777778vw;
    width: 2.777778vw;
    top: .208333vw;
}

.show {
    opacity: 0;
    rotate: 0;
    transition: all 1s ease;

}

.noshow {
    opacity: 1;
}

/* VueEditorStyles */

.vue__editor {
    width: 100%;
    border-color: #E3E3E9;
    border: .069444vw solid #E3E3E9;
    border-radius: 2.083333vw;
}

.vue__editor>>>.ql-toolbar.ql-snow {
    padding-top: .277778vw !important;
    padding-bottom: .277778vw !important;
    height: 2.777778vw !important;
    border-color: #DBDBDB;
    display: none;
}

.vue__editor>>>.quillWrapper .ql-snow.ql-toolbar .ql-formats {
    margin-bottom: 0 !important;
}

.vue__editor>>>.ql-toolbar.ql-snow .ql-formats {
    margin-right: 0 !important;
}

.vue__editor>>>.ql-toolbar.ql-snow+.ql-container.ql-snow {
    border-color: #fff;
    border: .069444vw solid #fff;
    border-radius: 2.083333vw;
}

.vue__editor>>>.ql-editor {
    min-height: unset !important;
    height: 8.194444vw;
    color: #323232 !important;
    font-family: "DM Sans" !important;

    font-size: .833333vw !important;
    line-height: normal !important;
    padding: 1.041667vw !important;

}

.vue__editor>>>.ql-editor.ql-blank::before {
    font-weight: 300 !important;
}

.classOfDay {
    cursor: pointer;
    background-color: #E3E3E9;
    border-radius: 1.388889vw;
    overflow: clip;
}

.classOfDayImage {
    height: 18.263889vw;
    position: relative;
    z-index: 2;
}

.classOfDayInfo {
    height: 7.361111vw;
    padding: .694444vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.classOfDayInfo p {
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    width: fit-content;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.classOfDayInfo h5 {
    overflow: hidden;
    color: var(--Text, #464D5B);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 500;


    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    align-self: stretch;
}

.classOfDayInfo span {
    font-family: "SharpGrotesk-Medium25";
    font-size: .694444vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;

    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

}

.classOfDayInfo h6 {
    color: var(--Text, #464D5B);
    text-align: right !important;
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.backdrop {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(70, 77, 91, 0.00) 27.78%, rgba(70, 77, 91, 0.20) 85.56%);
    mix-blend-mode: multiply;
    z-index: 2;
}

.classVideoPlay {
    position: absolute;
    left: 1.041667vw;
    top: .694444vw;
    z-index: 4;
    cursor: pointer;
}

.classDificulty {
    display: flex;
    flex-direction: row;
    gap: .208333vw;
    position: absolute;
    right: .694444vw;
    top: 1.041667vw;
    z-index: 3;
}

.classDificulty .disabled {
    filter: contrast(0) opacity(0.7)
}

.classTime {
    display: flex;
    flex-direction: row;
    gap: .416667vw;
    align-items: center;

    position: absolute;
    right: .694444vw;
    bottom: .694444vw;
    z-index: 4;

}

.classTime p {
    color: var(--Text, #464D5B);
    text-align: right;
    font-family: Manrope;
    font-size: .694444vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.AnabelNote {
    display: flex;
    padding: 1.388889vw;
    flex-direction: column;
    align-items: flex-start;
    gap: .347222vw;
    align-self: stretch;
    border-radius: 1.388889vw;
    background: #B359F8;
}

.AnabelNote>>>p {
    overflow: hidden;
    color: var(--White, #FFF);
    text-overflow: ellipsis;
    font-size: 1.1vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 100%;
}

.AnabelNote h6 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    align-self: stretch;
    overflow: hidden;
    color: var(--White, #FFF);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.AnabelNote p {
    overflow: hidden;
    color: var(--White, #FFF);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.dayRecipePrev {
    display: flex;
    flex-direction: column;
    overflow: clip;
    border-radius: 1.388889vw;
    cursor: pointer;
}

.dayRecipePrevImg {
    position: relative;
    height: 11.875vw;
}

.classOfDayImage img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.dayRecipePrevImg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.dayRecipePrevInfo {
    height: 5.277778vw;
    display: flex;
    padding: .694444vw;
    flex-direction: column;
    align-items: flex-start;
    gap: .347222vw;
    align-self: stretch;

    background-color: #E3E3E9;
}

.dayRecipePrevInfo p {
    overflow: hidden;
    color: var(--Text, #464D5B);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 500;
    line-height: 1.388889vw;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    align-self: stretch;
}

.classVideoPlay svg {
    width: 1.527778vw;
    height: 2.638889vw;
}

.classDificulty svg {
    width: 1.458333vw;
    height: 1.805556vw;
}

.mov {
    display: none !important;
}

.spinner {
    width: 1.388889vw;
    height: 1.388889vw;
    border-radius: 50%;
    border: .277778vw solid;
    border-color: #dbdcef;
    border-right-color: #b359f8;
    animation: spinner-d3wgkg 1s infinite linear;
}

.noteStatus {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.388889vw;
    height: 1.388889vw;
    position: absolute;
    right: .694444vw;
    bottom: .694444vw;
}

.noteStatus svg {
    width: 1.388889vw;
    height: 1.388889vw;
}

.changeWeek {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: .833333vw;
    width: 20vw;
    justify-content: flex-end;
}

.changeWeek p {
    color: var(--purple, #B359F8);
    text-align: center;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
}

@keyframes spinner-d3wgkg {
    to {
        transform: rotate(1turn);
    }
}

.calendarModal {
    display: flex;
    width: 38.541667vw;
    height: 100vh;
    padding: 2.083333vw 1.041667vw;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.388889vw;

    position: fixed;
    right: -40.625vw;
    top: 0vw;
    z-index: 100;

    border-radius: 2.083333vw 0vw 0vw 2.083333vw;
    background: #FFF;
    box-shadow: -0.486111vw 0vw 1.340278vw 0vw rgba(0, 0, 0, 0.15);
    transition: right 0.3s ease;
}

.calendarModalOpen {
    right: 0vw;
}

.backdropCalendarModal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.137);
    z-index: 99;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
}

.backdropShown {
    opacity: 1;
    pointer-events: all;
}

.modalHeader {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: .555556vw;
    align-self: stretch;
    cursor: pointer;
}

.modalHeader p {
    flex: 1 0 0;

    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.modalHeader svg {
    width: .972222vw;
    height: 1.180556vw;
}

.changeMonth {
    display: flex;
    flex-direction: row;
    width: 72%;
    justify-content: space-between;
    position: absolute;
    left: 13%;
    top: 1.041667vw;
}

.changeMonth button {
    width: 2.430556vw;
    height: 2.430556vw;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2.777778vw;
    border: #e6e6e6 solid .069444vw;
    transition: all 300ms ease;

}

.changeMonth button:hover {
    border: #4536EF solid .069444vw;
}

.changeMonth button:disabled {
    opacity: 0.3;
    cursor: auto;
}

.changeMonth button svg {
    width: .486111vw;
    height: 1.666667vw;
}

.resetMonth {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: absolute;
    right: 1.041667vw;
    top: 1.041667vw;
}

.resetMonth button {
    width: 2.430556vw;
    height: 2.430556vw;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2.777778vw;
    border: #e6e6e6 solid .069444vw;
    transition: all 300ms ease;

}

.resetMonth button:hover {
    border: #4536EF solid .069444vw;
}

.resetMonth button:disabled {
    opacity: 0.3;
    cursor: auto;
}

.resetMonth button svg {
    width: 1.111111vw;
    height: 1.111111vw;
    transform: translateY(-0.138889vw);

}


.calendarCont {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.041667vw;
    align-self: center;
}

.calendarCont h5 {
    color: #464D5B;
    text-align: center;
    font-family: Manrope;
    font-size: 1.736111vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
}

.calendar {
    width: 27.708333vw;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: .694444vw;
    padding: 1.041667vw;
    align-self: stretch;
    border-radius: 1.041667vw;
    border: .069444vw solid var(--background-gray, #E3E3E9);
    background: var(--White, #FFF);
}

.calendarHead {
    display: flex;
    flex-direction: row;
    gap: .590278vw;
}

.dayLabel {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    height: 1.111111vw;
    width: 3.125vw;
}

.dayCont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: .590278vw;
    overflow: hidden;
    left: 0;
    position: relative;
}

.day {
    height: 3.125vw;
    width: 3.125vw;
    border-radius: 2.083333vw;
    border: .069444vw solid var(--Text, #464D5B);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 8;

}

.day:disabled {
    background-color: #dddddd;
    opacity: 0.5;
    border: .069444vw solid var(--Text, #8e939b);

}

.gotInfo {
    height: .902778vw;
    width: .902778vw;
    border-radius: 1.388889vw;
    background: linear-gradient(270deg, #FFE711 0%, #96FF11 100%);
    position: absolute;
    top: 0;
    right: 0;
}

.day p {
    color: #464D5B;
    text-align: center;
    font-family: Manrope;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.today.day {
    background-color: #B359F8;
    border-color: #B359F8;
}

.today.day p {
    color: #FFF;

}

.passed {
    filter: grayscale(1) opacity(0.3);
    border: 0;
    pointer-events: none;
    user-select: none;
}

.diaCalSel::before {
    content: "";
    position: absolute;
    width: 25.486111vw;
    height: 3.2vw;
    background-color: rgba(201, 65, 255, 0.29);
    z-index: 5;
    pointer-events: none;
    left: 0;
    border-radius: 2.777778vw;
}

.errorMSG {
    overflow: hidden;
    color: var(--Text, #464D5B);
    text-overflow: ellipsis;
    font-family: Manrope;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    padding: 15px;
    border-radius: 15px;
    border: 1px #dbdbdb solid;

}

.errorMSG span {

    color: #B359F8;
    text-decoration: underline;
    cursor: pointer;
}

@media (max-width: 530px) {
    .pc {
        display: none !important;
    }

    .mov {
        display: flex !important;
    }

    .goBack {
        width: 100%;
    }

    .goBack p {
        width: 100%;
        text-align: center;

        color: var(--Text, #464D5B);
        font-family: Manrope;
        font-size: 4.186047vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .goBack svg {
        width: 3.255814vw;
        height: 3.255814vw;
    }

    section {
        gap: 4.651163vw !important;
    }

    .row {
        display: flex;
        flex-direction: row;
        justify-content: space-between
    }

    h3 {
        font-family: Manrope;
        font-size: 5.813953vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        width: fit-content;

        background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .rotate {
        transform: scaleY(-1);
    }

    .daySelect {
        flex-direction: column;
        align-items: center;
        gap: 2.325581vw;
        width: fit-content;
        border-radius: 11.627907vw;
        padding: 2.190698vw;
        width: 100%;
    }

    .daySelect p {
        margin-left: 0;
        font-size: 4.186047vw;
        margin-top: 10.465116vw;
        font-variant-numeric: tabular-nums;
    }

    .daySelect svg {
        margin-left: 0;
        width: 3.023256vw;
        height: 3.255814vw;
    }

    .finish {
        width: 5.581395vw;
        height: 5.581395vw;
        border-radius: 6.976744vw;
        top: 2.790698vw;
        left: 50%;
        transform: translateX(-50%);
    }

    .selected::before {
        inset: -0.930233vw !important;
    }

    .weekSelector {
        justify-content: space-between;
    }

    .dayClass {
        width: 100%;
        margin-bottom: 18.604651vw;
    }

    .dayRecipe {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .dayRecipe h5 {
        display: none;
    }

    .dayInfoCont {
        flex-direction: column;
        gap: 4.651163vw;
    }

    .infoCard {
        padding: 0;
        border: 0;
        border-radius: 0;
        align-items: stretch
    }

    .infoCard>span {
        display: none
    }

    .dayClassTitle {
        flex-direction: row;
        justify-content: space-between;
    }

    .dayClassTitle h4 {
        font-size: 2.790698vw;
    }

    .dayClassTitle span {
        font-size: 2.790698vw;
        width: 60.465116vw;
        line-height: normal;
    }

    .classOfDay {
        border-radius: 4.651163vw;
    }

    .classOfDayImage {
        height: 30vw;
    }

    .classOfDayInfo {
        height: 21.860465vw;
        padding: 2.790698vw 2.325581vw;
    }

    .classOfDayInfo p {
        font-size: 2.325581vw;
    }

    .classOfDayInfo h5 {
        font-size: 2.790698vw;
    }

    .classOfDayInfo span {
        font-size: 2.325581vw;
    }

    .classOfDayInfo h6 {
        font-size: 2.325581vw;
    }

    .classVideoPlay {
        top: 2.325581vw;
        left: 2.325581vw;
    }

    .classVideoPlay svg {
        width: 2.790698vw;
        height: 5.348837vw;
    }

    .classDificulty {
        top: 2.325581vw;
        right: 2.325581vw;
    }

    .classDificulty svg {
        width: 2.55814vw;
        height: 3.023256vw;
    }

    .classTime {
        bottom: 2.325581vw;
        right: 2.325581vw;
        gap: 2.325581vw
    }

    .classTime p {
        color: var(--White, #FFF);
        text-align: right;
        font-family: Manrope;
        font-size: 2.325581vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .classTime svg {
        width: 2.55814vw;
        height: 2.55814vw;
    }

    h5 {

        font-family: Manrope;
        font-size: 2.790698vw;
        font-style: normal;
        font-weight: 600;
        line-height: normal;

        background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .dayRecipe {
        display: flex;
        padding: 3.488372vw !important;
        align-items: center;
        gap: 3.488372vw !important;
        align-self: stretch;

        border-radius: 6.976744vw;
        border: .232558vw solid var(--background-gray, #E3E3E9);
        background: #FFF;
    }

    .moodList {
        justify-content: flex-start;
        gap: 2.325581vw;
        padding: 0 3.488372vw;
        overflow-x: scroll;
        scrollbar-width: none;
        /* Firefox */
        -ms-overflow-style: none;
        /* Internet Explorer 10+ */
    }

    .moodList::-webkit-scrollbar {
        display: none;
        /* Safari and Chrome */
    }

    .mood {
        min-width: 22.093023vw;
        min-height: 28.139535vw;
        padding: 3.488372vw 0;
    }

    .mood p {
        font-size: 2.325581vw;
    }

    .moodImage {
        width: 15.861111vw;
        height: 15.861111vw;
    }

    .moodImage img {
        height: 8.777778vw;
        width: 8.777778vw;
    }

    .moodImage svg {
        width: 15.861111vw;
        height: 15.861111vw;
    }

    .dayRecipePrev {
        width: 100%;
        border-radius: 4.651163vw;

    }

    .dayRecipePrevImg {
        height: 39.767442vw;
    }

    .dayRecipePrevInfo {
        height: 17.674419vw;
        padding: 2.325581vw;
    }

    .dayRecipePrevInfo p {
        font-size: 4.186047vw;
        line-height: 4.651163vw;
    }

    .AnabelNote {
        width: 100%;
        border-radius: 4.651163vw;
        padding: 2.325581vw;
    }

    .AnabelNote h6 {
        font-size: 4.186047vw;
    }

    .AnabelNote p {
        font-size: 2.790698vw;
    }

    .vue__editor>>>.ql-editor {
        height: 26.27907vw;
        padding: 3.488372vw !important;
        font-size: 3.488372vw !important;
    }

    .vue__editor {
        border-radius: 4.651163vw;
    }

    .spinner {
        height: 4.651163vw;
        width: 4.651163vw;
        border: .977778vw solid;
        border-color: #dbdcef;
        border-right-color: #b359f8;
    }

    .noteStatus {
        height: 4.651163vw;
        width: 4.651163vw;
        right: 2.325581vw;
        bottom: 2.325581vw;
    }

    .noteStatus svg {
        height: 4.651163vw;
        width: 4.651163vw;
    }

    .AnabelNote>>>p {
        font-size: 3vw;
    }

    .row span {
        display: none;
    }

    .changeWeek {
        width: 50%;
        justify-content: space-between;
    }

    .changeWeek p {
        font-size: 3.488372vw;
    }

    .calendarModal {
        width: 100vw;
        right: -120vw;
    }

    .calendarModalOpen {
        border-radius: 0;
        right: 0vw;
    }

    .modalHeader {
        padding: 30px 15px;
    }

    .modalHeader svg {
        width: 3.972222vw;
        height: 4.180556vw;
    }

    .modalHeader p {
        font-size: 4.25vw;
    }

    .calendar {
        width: 80vw;
        padding: 2.083333vw;
        border-radius: 4.083333vw;
    }

    .calendarCont h5 {
        font-size: 6.25vw;
    }

    .calendarCont {
        gap: 8vw;
    }

    .changeMonth {
        display: flex;
        flex-direction: row;
        width: 80%;
        justify-content: space-between;
        position: absolute;
        left: 10%;
        top: -0.958333vw;

    }

    .changeMonth button svg {
        width: 7.486111vw;
        height: 3.666667vw;
    }

    .changeMonth button {
        width: 10.430556vw;
        height: 10.430556vw;
        border-radius: 50%;
    }

    .dayLabel {
        font-size: 3.333333vw;
        flex: 1;
        width: 10vw;
        height: auto;
    }

    .dayCont {
        gap: 1vw 0.690278vw;
    }

    .day {
        height: 10.125vw;
        width: 10.125vw;
        border-radius: 10vw;
    }

    .day p {
        font-size: 3.441667vw;
    }

    .diaCalSel::before {
        width: 99%;
        height: 10.2vw;
        border-radius: 50vw;
    }
}
</style>